<template>
  <v-container fluid class="pa-0">
    <DialogSelectPeergroup ref="dlgSelectPeergroup" @doItem="loadPeergroup" @doReload="loadPGList"></DialogSelectPeergroup>
    <DialogDoExport ref='dlgDoExport'></DialogDoExport>
    <SearchRulesManager ref="searchRulesManager" :hitlistMode="hitlistMode" :showManager="showSearch"></SearchRulesManager>
    <v-layout row fluid>
      <v-flex style="padding: 0px; margin: 0px;">
        <v-card flat style="padding: 0px; margin: 0px;">
          <v-card-text style="padding: 0px; margin: 0px;">
            <FixedTableIE :widthSub="0" :heightSub="getHeightSub()" :containerHeight="innerHeight" :ankerBank="null" ref="sdTable"
                          :currency="currentCurrency"
                          :selected="selected"
                          configSuffix="hitlistpgSearch" tableName=""
                          :headerConfigName="'Peergroup'"
                          @selectedRows="selectedRows"
                          :tableConfig='tableConfig' :tableNotComplete="tableNotComplete"
                          :headers="headers" :items="pgresults" class="colorrows isactive"></FixedTableIE>
            <div v-if="((pgresults === null))" class="font-weight-bold bluetext textleft missingDataInPeergroup">{{
              'TITLE_PEERGROUP_SELECT_FILTERS' | translate}}
            </div>
          </v-card-text>
          <v-card-actions>
            <!--
            <v-btn small color='#004884' dark class="text-none mx-3" outline @click="forwardToOverview">{{
              'BUTTON_FORWARD_TO_PGOVERVIEW' | translate}}
            </v-btn>
            -->
            <v-btn v-if="canExport" outline class="text-none" color="#004884" @click="doExport()" small>
              {{ 'BUTT_SUBMIT_EXCEL' | translate}}
            </v-btn>

            <v-btn color="#004884" class="text-none" outline small @click="showLoadPGDialog()">{{ 'BUTT_LOAD_PEERGROUP'
              | translate}}
            </v-btn>
            <v-spacer></v-spacer>
            <HitlistPager></HitlistPager>
            &nbsp; &nbsp;
            <span v-if="sRows" class="font-weight-bold bluetext">&nbsp;{{ 'TABLE_SELECTION_COUNT' | translate}}: {{sRows}}</span>

            <v-spacer></v-spacer>

            <!--
            <v-btn v-if="(pgresults != null) && (pgresults.length > 0) && shwButton" small color='blue' dark class="text-none mx-3" @click="addModelsToGroup(false)">{{ 'BUTT_ADD_NO_FORWARD' | translate}}</v-btn>
            <v-btn v-if="(pgresults != null) && (pgresults.length > 0) && shwButton" small color='blue' dark class="text-none mx-3" @click="addModelsToGroup(true)">{{ 'BUTT_ADD' | translate}}</v-btn>
            -->
            <v-btn v-if="(pgresults != null) && (pgresults.length > 0) && shwButton" small color='blue' dark class="text-none mx-3" @click="forwardToOverview()">{{ 'BUTTON_FORWARD_TO_PGOVERVIEW' | translate}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import SearchRulesManager from './mask/SearchRulesManager';
  import Vue from 'vue'
  import FixedTableIE from './../tables/EasyTableIE'
  import HitlistPager from "../widgets/HitlistPager"
  import DialogSelectPeergroup from './../module/dialogs/DialogSelectPeergroup';
  import DialogDoExport from './../module/dialogs/DialogDoExport';

  export default {
    name: 'Peergroup.vue',
    components: {HitlistPager, SearchRulesManager, FixedTableIE, DialogSelectPeergroup, DialogDoExport},
    data() {
      return {
        showSearch: false,
        showHitlist: true,
        innerHeight: 400,
        hitlistMode: 'balances',
        reqHistlist: { state: null },

        currentSearchData: null,
        pageCache: [],
        canExport: false,

        userPGList: [],
        link: '',
        balance: null,
        target: '',
        first: true,
        myData: null,
        widthSub: 370,

        s: true,
        tableNotComplete: false,
        shwButton: false,
        headers: [],
        pgresults: null,
        showForward: true,
        maskHeight: 580,
        sRows: '',
        currentCurrency: '1',
        storeOldPeergroup: null,
        bankAnchor: null,
        selected: [],
        idModule: '',
        idModuleItem: '',
        'tableConfig': {
          selection: true,
          header: {
            columnClass: 'verlauf abstandunten04 theme--light blue tableIEPadding1 headcolumn'
          },
          rows: {
            rowClass: 'rowEIE'
          }
        }
      }
    },
    methods: {
      setSearchMode: function (newMode) {
        this.showHitlist = !newMode;
        this.showSearch = newMode;

        this.$nextTick(function () {
          window.dispatchEvent(new Event('resize'));
        });
      },
      onResize: function (event) {
        const view = Vue.prototype.$api.viewport();
        const footerHeight = 36;
        const headerHeight = 60;
        const searchItemTitleHeight = 30 + 16;

        const filtersetHeight = this.$refs.searchRulesManager.$el.clientHeight;

        let h2 = view.height - footerHeight - headerHeight - filtersetHeight - searchItemTitleHeight;
        this.innerHeight = h2;

      },
      onSearchRulesManagerAction: function (newMode, data) {
        if (newMode) {
          this.setSearchMode(true);
          // data???
        }
        else {
          this.setSearchMode(false);
          this.submitSearch(data);
        }
      },
      submitSearch (data) {
        const cmp = this;
        let searchData = {};
        searchData['action'] = 'hitlist';
        searchData['filter'] = data.filter;
        searchData['sources'] = data.sources;
        searchData['columns'] = this.headerFields;
        searchData.mode = this.hitlistMode;
        if (!isNaN(data.totalHits)) searchData['totalHits'] = data.totalHits;
        if (searchData['filter'].length == 0) {
          return;
        }
        if (searchData['filter'].length > 1) {
          searchData['formula'] = data.formula;
        }
        Vue.prototype.$api.showIdle();
        Vue.prototype.$api.getHitlist(searchData, this.reqHistlist, function(data) {
          Vue.prototype.$api.hideIdle();
          if (data && data.table && data.table.columns) {
            let columns = [];
            for (const c of data.table.columns) {
              columns.push (c.id);
            }
            cmp.headerFields = columns;
          }
          cmp.onGetHitList(data);
        }); 
      },
      submitExport () {
        const cmp = this;

        Vue.prototype.$api.showIdle();
        Vue.prototype.$api.getExportInfo(this.hitlistMode, this.currentSearchData, function (data) {
          Vue.prototype.$api.hideIdle();

          if (data.totalHits > 1000000) {
            Vue.prototype.$eventHub.$emit('OnShowError', {
              isDetail: true,
              title: "Trefferliste exportieren",
              message: "Mehr als 1.000.000 Treffer können nicht exportiert werden, da Excel eine Zeilenbegrenzung hat."
            });
          }
          else if (data.totalHits > 10000) {
            cmp.$refs.dlgDoExport.open({
              title: "TITLE_EXPORT_HITLIST",
              description: "QUEST_EXPORT_LARGE_HITLIST",
              countHits: Vue.prototype.$api.formatLocaleNumber('n0', data.totalHits),
              exportCaption: "EXPORT_HITLIST_CAPTION",
              exportType: cmp.hitlistMode,
              searchData: cmp.currentSearchData
            });
          }
          else {
            Vue.prototype.$api.showIdle();
            let searchData = JSON.parse(JSON.stringify(cmp.currentSearchData));
            Vue.prototype.$api.getHitlistDownload(searchData, cmp.hitlistMode, function() { Vue.prototype.$api.hideIdle() });
          }
        }, Vue.prototype.$api.onAjaxFailure);
      },

      collapseEvent: function (isMini) {
        if (isMini) {
          this.widthSub = 96
        } else {
          this.widthSub = 370
        }
      },
      doExport () {
        Vue.prototype.$eventHub.$emit('onExecuteExport');
        this.submitExport();
      },
      getHeightSub() {
        return 62
      },
      loadPGList() {
        Vue.prototype.$api.getPeergroupList(this.onGetPeergroupList)
      },
      onGetPeergroupList(list) {
        Vue.prototype.$api.debug('onGetPeergroupList', list)
        this.userPGList = list
      },
      loadPeergroup(pgId) {
        Vue.prototype.$api.debug('loadPeergroup', pgId)
        Vue.prototype.$api.loadPeergroupListById(pgId, this.onGetPeergroupLisById)
      },
      onGetPeergroupLisById(list) {
        Vue.prototype.$api.debug('onGetPeergroupLisById', list)
        this.loadedPGList = list.balanceArray
        Vue.prototype.storage.ankerBank = null
        Vue.prototype.storage.hasAnkerBank = false
        Vue.prototype.storage.peergroupData[Vue.prototype.$api.getModuleId()] = []
        Vue.prototype.storage.peergroupDataRows[Vue.prototype.$api.getModuleId()] = []

        Vue.prototype.storage.resetAnkerbank(Vue.prototype.$api.getModuleId())
        if (list.ankerBank) {
          this.hasAnkerBank = true
          Vue.prototype.storage.hasAnkerBank = true
          Vue.prototype.storage.ankerBank = Vue.prototype.$api.stringToBalance(list.ankerBank)
          this.ankerBank = Vue.prototype.storage.ankerBank
          Vue.prototype.storage.setAnkerbank(Vue.prototype.$api.getModuleId(), Vue.prototype.storage.ankerBank)
          Vue.prototype.storage.setAnkerbankData(Vue.prototype.$api.getModuleId(), {
            title: '',
            balance: Vue.prototype.storage.ankerBank
          })
        }
        this.headerFields = [ 2, 1, 3, 17, 16, 15, 14 ];
        Vue.prototype.$api.getBalanceDataWithBalanceStringArray(list.balanceArray, this.headerFields, this.onGetBalances)
      },
      onGetBalances(tableData) {
        Vue.prototype.$api.debug('onGetBalances', tableData)
        var result = Vue.prototype.$api.prepareWaimeaTable(tableData.table)
        this.pgresults = result.rows

        let missingTitle = false
        if (this.ankerBank) {
          if (Vue.prototype.storage.getAnkerbankData(Vue.prototype.$api.getModuleId()).title === '') {
            missingTitle = true
          }
        }

        var pgData = []
        for (var i in this.pgresults) {
          var item = this.pgresults[i]
          if (this.hasAnkerBank) {
            if (Vue.prototype.$api.compareBalance(item.meta.balance, Vue.prototype.storage.ankerBank)) {
              item.meta.balance.isAnkerBank = true
              if (missingTitle) {
                Vue.prototype.storage.setAnkerbankData(Vue.prototype.$api.getModuleId(), {
                  title: item[1].co,
                  balance: Vue.prototype.storage.ankerBank
                })
              }
            }
          }
          pgData.push(item.meta.balance)
        }

        Vue.prototype.storage.setPeergroup(Vue.prototype.$api.getModuleId(), pgData)

        this.$router.push(this.linkOverview)

      },

      openTable: function () {
        Vue.prototype.$api.debug('openTable')
        let cmp = this
        if (this.$refs.sdTable && this.$refs.sdTable.updateData) {
          let orderCellName = null
          if (!this.$refs.sdTable.orderIsSet()) {
            for (var i = 0;i < this.headers.length; i++) {
              let headItem = this.headers[i]
              // if (headItem.meta.id.indexOf('Name') > -1) {
              //   orderCellName = i + 1
              //   cmp.first = false
              //   break;
              // }
            }
          }

          this.$refs.sdTable.updateHeader(this.headers)
          this.$refs.sdTable.updateData(this.pgresults, true, orderCellName)
          this.shwButton = true
          window.setTimeout(function () {
            cmp.selectedRows({
              selected: cmp.$refs.sdTable.getSelectedRows(),
              selectedBefore: []
            })
          }, 100)

          Vue.prototype.$eventHub.$emit('updatehitlistpager', { page: this.page });

          // Cache next page
          if (this.page < this.pageCount) {
            // Disabled - SQLDEBUG
            //this.getPageData(this.page+1, false);
          }

        }
        Vue.prototype.$api.debug('openTable done')
      },
      selectedRows(rows) {
        this.sRows = ''
        if (rows && rows.selected.length > 0) {
          this.sRows = '' + rows.selected.length
        }
        this.removeModelsFromGroup(false, rows.selectedBefore)
        this.addModelsToGroup(false)
        // Vue.prototype.$eventHub.$emit('hitlistcounter', {
        //   hits: this.myData.table.rows.length,
        //   totalHits: this.myData.totalHits,
        //   totalHitsAppendix: this.myData.totalHitsAppendix
        // })

        // this.updateSelectedEntries(this.pgresults)
        // this.openTable()
      },
      forwardToOverview() {
        this.$refs.sdTable.clearMemoryLeaks()
        this.$router.push(this.linkOverview)
      },
      showLoadPGDialog() {
        this.$refs.dlgSelectPeergroup.open(this.userPGList)
      },
      removeModelsFromGroup(doForward, models) {
        Vue.prototype.$eventHub.$emit('EventStoreSearchData')
        this.selected = this.$refs.sdTable.getSelected()
        Vue.prototype.$api.debug('removeModelsFromGroup', models)
        for (var itemIndex in models) {
          var item = models[itemIndex]
          if (item.meta.balance.isAnkerBank) continue
          Vue.prototype.storage.deleteFromPeergroup(Vue.prototype.$api.getModuleId(), item.meta.balance)
        }
        if (doForward) {
          this.$refs.sdTable.clearMemoryLeaks()
          this.$router.push(this.linkOverview)
        }
      },
      addModelsToGroup(doForward) {
        Vue.prototype.$eventHub.$emit('EventStoreSearchData')
        this.selected = this.$refs.sdTable.getSelected()
        Vue.prototype.$api.debug('addModelsToGroup', this.selected)
        var pgList = Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId())
        for (var itemIndex in this.selected) {
          var item = this.selected[itemIndex]
          var aString = Vue.prototype.$api.balanceToString(item.meta.balance)
          var idx = _.findIndex(pgList, function (storageItem) {
            var bString = Vue.prototype.$api.balanceToString(storageItem)
            return (aString === bString)
          })
          var alreadyExists = idx > -1
          if (!alreadyExists) {
            Vue.prototype.storage.addToPeergroup(Vue.prototype.$api.getModuleId(), item.meta.balance, item)
          }
        }
        if (doForward) {
          this.$refs.sdTable.clearMemoryLeaks()
          this.$router.push(this.linkOverview)
        }
      },
      /*
      open: function () {
        this.headers = []
        var result = Vue.prototype.$api.prepareWaimeaTable(this.myData.table)
        this.pgresults = result.rows
        this.headers = result.headers

        Vue.prototype.storage.currentHeader = this.headers

        Vue.prototype.$api.debug('updateSelectedEntries')
        this.updateSelectedEntries(this.pgresults)
        Vue.prototype.$api.debug('updateSelectedEntries done')
        if (this.myData && this.myData.table && this.myData.table.rows && this.myData.table.rows) {
          Vue.prototype.$eventHub.$emit('hitlistcounter', {
            hits: this.myData.table.rows.length,
            totalHits: this.myData.totalHits,
            totalHitsAppendix: this.myData.totalHitsAppendix
          })
        } else {
          Vue.prototype.$eventHub.$emit('hitlistcounter', {
            hits: -1,
            totalHits: -1,
            totalHitsAppendix: ''
          })
        }
        Vue.prototype.storage.saveState('pgoverviewHeader', result.headers)

        this.openTable()
      },
      */
      updateSelectedEntries(data) {
        var ankerBankFound = false
        for (var index in data) {
          var item = data[index].meta
          item.selected = false
          item.value = 0
          if (Vue.prototype.storage.hasAnkerBank) {
            if (Vue.prototype.$api.compareBalance(item.balance, Vue.prototype.storage.ankerBankBalance)) {
              item.selected = true
              item.value = 1
              ankerBankFound = false
            }
          }
          //if (Vue.prototype.$api.checkBalanceExistsInGroup(item.balance)) {
          if (Vue.prototype.storage.isInPeergroup(item.balance)) {
            item.selected = true
            item.value = 1
          }
        }
      },
      close: function () {
        Vue.prototype.$api.debug('close')
        if (this.$refs.sdTable && this.$refs.sdTable.doDestroyTable) {
          this.$refs.sdTable.doDestroyTable()
        }
      },
      onGetHitList: function (data) {
        Vue.prototype.$api.debug("onGetHitlist", data);
        this.currentSearchData = data.searchData;

        data.info = [];
        if (data.execTimePerformSql) data.info['time'] = data.execTimePerformSql;
        if (data.query) data.info['sql'] = data.query;
        if (data.totalHits && data.totalHits > 0) {
          this.canExport = true;
          Vue.prototype.$eventHub.$emit('updatehitlistpager', {
            info: data.info,
            totalHits: +data.totalHits,
            hitsPerPage: +data.hitsPerPage,
            page: 1
          });
        } else {
          this.canExport = false;
          Vue.prototype.$eventHub.$emit('updatehitlistpager', {
            info: data.info,
            totalHits: 0,
            hitsPerPage: 0,
            page: 0
          });
        }

        this.headers = [];
        this.pageCache = [];
        let result = Vue.prototype.$api.prepareWaimeaTable(data.table);
        this.headers = result.headers;
        this.pageCache[this.page] = result.rows;
        this.pgresults = this.pageCache[this.page];

        // TODO check this
        Vue.prototype.storage.currentHeader = this.headers

        Vue.prototype.$api.debug('updateSelectedEntries')
        this.updateSelectedEntries(this.pgresults)
        Vue.prototype.$api.debug('updateSelectedEntries done')
        Vue.prototype.storage.saveState('pgoverviewHeader', result.headers)


        Vue.prototype.storage.saveState('pgLastHitList_' + this.target, data);
        this.openTable();
      },
      onSubmit: function () {
        // console.log('onSubmit')
        this.sRows = ''
      },
      onBackButtonClick: function (source) {
        console.log('onBackButtonClick', source)
        Vue.prototype.storage.resetPeergroup(Vue.prototype.$api.getModuleId())
        if (JSON.parse(this.storeOldPeergroup)) {
          Vue.prototype.storage.setPeergroup(Vue.prototype.$api.getModuleId(), JSON.parse(this.storeOldPeergroup))
        }

      }
    },
    created() {
      Vue.prototype.$eventHub.$on('OnGetHitList', this.onGetHitList)
      Vue.prototype.$eventHub.$on('OnBackButtonClick', this.onBackButtonClick)

      Vue.prototype.$eventHub.$on('SearchRulesManagerAction', this.onSearchRulesManagerAction);
      window.addEventListener("resize", this.onResize);
    },
    destroyed() {
      Vue.prototype.$eventHub.$off('OnGetHitList', this.onGetHitList)
      Vue.prototype.$eventHub.$off('OnBackButtonClick', this.onBackButtonClick)

      Vue.prototype.$eventHub.$off('SearchRulesManagerAction', this.onSearchRulesManagerAction);
      window.removeEventListener("resize", this.onResize);
    },
    mounted() {
      var cmp = this
      cmp.first = true
      var view = Vue.prototype.$api.viewport()
      var footerHeight = 0
      this.currentCurrency = Vue.prototype.storage.getCurrency()

      this.storeOldPeergroup = JSON.stringify(Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId()))
      if ($('#footerMenu')) {
        footerHeight = $('#footerMenu').height()
      }
      var h2 = view.height - footerHeight - Vue.prototype.storage.appConfig.TABLE_SHRINK_HEIGHT + 34
      cmp.maskHeight = h2

      this.showForward = true
      if (!Vue.prototype.storage.isPeergroup(Vue.prototype.$api.getModuleId())) {
        this.showForward = false
      }

      this.setSearchMode(true);

      Vue.prototype.$eventHub.$emit('updatehitlistpager', {
        hits: -1,
        totalHits: -1,
      })
      Vue.prototype.$api.getHitlistConfiguration(this.hitlistMode, "", function (data) {
        Vue.prototype.$api.debug('onGetHitListConfig', data);
        cmp.headerFields = data;
        Vue.prototype.storage.currentHeaderFields = data;
      });
      // this.currencyDimensions = [];
      // this.currencyDimensions.push({id: 1, name: "€"})
      // for (let i = 2; i <= 3; i++) {
      //   let dimension = Vue.prototype.$api.getI18NCurrencyDimension(i);
      //   this.currencyDimensions.push({id: dimension.id, name: dimension.name + " €"})
      // }

      Vue.prototype.$api.checkCredentials(cmp, function () {
        if (cmp.$route.params) {
          cmp.idModule = cmp.$route.params.idModule
          cmp.idModuleItem = cmp.$route.params.idModuleItem

          if (Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
            Vue.prototype.storage.ankerBank = Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId())
            Vue.prototype.storage.hasAnkerBank = true
          } else {
            cmp.balance = null
          }

          cmp.target = cmp.idModule + '_balances';
          Vue.prototype.$api.debug('target', cmp.target);
          let data = Vue.prototype.storage.getState('pgLastHitList_' + cmp.target);
          if (data) {
            cmp.onGetHitList(data);
          }

        }
        Vue.prototype.$api.getBreadCrumpModule(cmp.idModule)
        cmp.link = '/di/StructureData/' + cmp.idModule
        cmp.linkOverview = '/di/peergroup/' + cmp.idModule + '/overview'
        cmp.loadPGList()
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/Peergroup.vue